<template>

  <div :class="`col-lg-6 quick-access col-xl-${options.colSize || 3}`">

    <list-groups :options="options">

      <span slot="action" class="label label-success">
        {{ pagination.total }}
      </span>

      <b-list-group-item
        slot="card"
        v-for="item in items"
        :key="item.id" :href="options.link.href + item.id || '#!'"
        :target="options.link.target || '_self'"
        class="flex-column align-items-start quick-access">

        <div class="w-100 justify-content-between">

          <h5 class="w-100 mb-0" v-if="item.name">
            {{ item.name }}
          </h5>

          <small class="w-100 item-hour" v-if="item.created_at" style="padding-top: 4px;">
            
            <b>
              <i class="fa fa-clock-o" aria-hidden="true"></i> {{ item.created_at | moment('DD/MM/YYYY HH:mm') }}
            </b>
            
          </small>

        </div>

      </b-list-group-item>

    </list-groups>

  </div>

</template>

<script>
import { resolveHTTP } from '@/services/api'

export default {
  name: 'widget-system-user',
  data () {
    return {
      items: [],
      pagination: [],
      options: {
        name: 'Últimos Cadastros',
        caption: '',
        colSize: 3,
        entity: {
          url: '/system/users',
          params: {
            per_page: 5,
            _order: 'id:desc'
          }
        },
        link: {
          href: '#/sys-users/',
          target: '_self'
        }
      }
    }
  },
  methods: {
    refresh () {
      let self = this
      resolveHTTP(self.options.entity.url).index({
        params: self.options.entity.params
      }).then(function (res) {
        self.items = res.data.collection
        self.pagination = res.data.pagination
      })
    }
  },
  created () {
    this.refresh()
  }
}
</script>

<style lang="scss" scoped>
  
  .item-hour {
    color: #ccc;
    font-size: 12px !important;
  }
  
  .list-group-item {
    &:hover {
      
      h5 {
        color: #01a1db !important;
      }
      
    }
  }

  .card-body {

    h5 {
      line-height: 24px;
      color: #3e515b;
    }
  }
  .card-header {
    .card-actions {
      .label {
       padding: 15px 0px;
       border-radius: 0px;
       display: inline-block;
       background: #01a1db; /* Old browsers */
       background: -moz-linear-gradient(45deg, #01a1db 0%, #1ed3f2 100%); /* FF3.6-15 */
       background: -webkit-linear-gradient(45deg, #01a1db 0%,#1ed3f2 100%); /* Chrome10-25,Safari5.1-6 */
       background: linear-gradient(45deg, #01a1db 0%,#1ed3f2 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
       filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#01a1db', endColorstr='#1ed3f2',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
     }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/System/User.vue